module.exports = __webpack_public_path__ + "static/img/index-logo.d7ef07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-logo.png
// module id = XQoL
// module chunks = 9